module.exports = __webpack_public_path__ + "static/media/book.5a89ab1e.svg";